import * as ambassadorWixSocialGroupsV2Group from './social-groups-v2-group-groups.http.js';
import * as ambassadorWixSocialGroupsV2GroupTypes from './social-groups-v2-group-groups.types.js';
import * as ambassadorWixSocialGroupsV2GroupUniversalTypes from './social-groups-v2-group-groups.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSocialGroupsV2GroupUniversalTypes.CreateGroupRequest,
  ambassadorWixSocialGroupsV2GroupTypes.CreateGroupRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.CreateGroupResponse,
  ambassadorWixSocialGroupsV2GroupTypes.CreateGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2Group.createGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateGroup(): __PublicMethodMetaInfo<
  'PATCH',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupUniversalTypes.UpdateGroupRequest,
  ambassadorWixSocialGroupsV2GroupTypes.UpdateGroupRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.UpdateGroupResponse,
  ambassadorWixSocialGroupsV2GroupTypes.UpdateGroupResponse
> {
  const payload = { group: { id: ':groupId' } } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2Group.updateGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/groups/{group.id}',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteGroup(): __PublicMethodMetaInfo<
  'DELETE',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupUniversalTypes.DeleteGroupRequest,
  ambassadorWixSocialGroupsV2GroupTypes.DeleteGroupRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.DeleteGroupResponse,
  ambassadorWixSocialGroupsV2GroupTypes.DeleteGroupResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2Group.deleteGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/groups/{groupId}',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getGroup(): __PublicMethodMetaInfo<
  'GET',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupUniversalTypes.GetGroupRequest,
  ambassadorWixSocialGroupsV2GroupTypes.GetGroupRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.GetGroupResponse,
  ambassadorWixSocialGroupsV2GroupTypes.GetGroupResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions = ambassadorWixSocialGroupsV2Group.getGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/groups/{groupId}',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getGroupBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixSocialGroupsV2GroupUniversalTypes.GetGroupBySlugRequest,
  ambassadorWixSocialGroupsV2GroupTypes.GetGroupBySlugRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.GetGroupBySlugResponse,
  ambassadorWixSocialGroupsV2GroupTypes.GetGroupBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2Group.getGroupBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/groups/slugs/{slug}',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listGroups(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixSocialGroupsV2GroupUniversalTypes.ListGroupsRequest,
  ambassadorWixSocialGroupsV2GroupTypes.ListGroupsRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.ListGroupsResponse,
  ambassadorWixSocialGroupsV2GroupTypes.ListGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2Group.listGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryGroups(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSocialGroupsV2GroupUniversalTypes.QueryGroupsRequest,
  ambassadorWixSocialGroupsV2GroupTypes.QueryGroupsRequest,
  ambassadorWixSocialGroupsV2GroupUniversalTypes.QueryGroupsResponse,
  ambassadorWixSocialGroupsV2GroupTypes.QueryGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2Group.queryGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Group as GroupOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Events as EventsOriginal,
  Logo as LogoOriginal,
  GroupDetailsPosition as GroupDetailsPositionOriginal,
  Image as ImageOriginal,
  Position as PositionOriginal,
  AllowPolicy as AllowPolicyOriginal,
  AllowPolicyWithLiterals as AllowPolicyWithLiteralsOriginal,
  OnboardingStepSettings as OnboardingStepSettingsOriginal,
  StepKey as StepKeyOriginal,
  StepKeyWithLiterals as StepKeyWithLiteralsOriginal,
  PrivacyStatus as PrivacyStatusOriginal,
  PrivacyStatusWithLiterals as PrivacyStatusWithLiteralsOriginal,
  AccessRestriction as AccessRestrictionOriginal,
  AccessRestrictionDataOneOf as AccessRestrictionDataOneOfOriginal,
  GroupDetails as GroupDetailsOriginal,
  CoverImage as CoverImageOriginal,
  GroupSettings as GroupSettingsOriginal,
  Identity as IdentityOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  CreateGroupRequest as CreateGroupRequestOriginal,
  ContentType as ContentTypeOriginal,
  ContentTypeWithLiterals as ContentTypeWithLiteralsOriginal,
  CreateGroupResponse as CreateGroupResponseOriginal,
  UpdateGroupRequest as UpdateGroupRequestOriginal,
  UpdateGroupResponse as UpdateGroupResponseOriginal,
  GroupCoverChanged as GroupCoverChangedOriginal,
  GroupDescriptionChanged as GroupDescriptionChangedOriginal,
  DeleteGroupRequest as DeleteGroupRequestOriginal,
  DeleteGroupResponse as DeleteGroupResponseOriginal,
  GetGroupRequest as GetGroupRequestOriginal,
  GetGroupResponse as GetGroupResponseOriginal,
  GetGroupBySlugRequest as GetGroupBySlugRequestOriginal,
  GetGroupBySlugResponse as GetGroupBySlugResponseOriginal,
  GetGroupIdBySlugRequest as GetGroupIdBySlugRequestOriginal,
  GetGroupIdBySlugResponse as GetGroupIdBySlugResponseOriginal,
  GlobalFeedPermissions as GlobalFeedPermissionsOriginal,
  FeedPermissions as FeedPermissionsOriginal,
  FeedItemPermissions as FeedItemPermissionsOriginal,
  ListGroupsRequest as ListGroupsRequestOriginal,
  ListGroupsResponse as ListGroupsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  ListGroupsByUserIdRequest as ListGroupsByUserIdRequestOriginal,
  ListGroupsByUserIdResponse as ListGroupsByUserIdResponseOriginal,
  GroupWithMsId as GroupWithMsIdOriginal,
  QueryGroupsRequest as QueryGroupsRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryGroupsResponse as QueryGroupsResponseOriginal,
  QueryJoinedGroupsRequest as QueryJoinedGroupsRequestOriginal,
  QueryJoinedGroupsResponse as QueryJoinedGroupsResponseOriginal,
  QueryGroupsByMembershipRequest as QueryGroupsByMembershipRequestOriginal,
  MembershipStatus as MembershipStatusOriginal,
  MembershipStatusWithLiterals as MembershipStatusWithLiteralsOriginal,
  GroupPermissions as GroupPermissionsOriginal,
  QueryGroupsByMembershipResponse as QueryGroupsByMembershipResponseOriginal,
  ListGroupIntegrationsDataRequest as ListGroupIntegrationsDataRequestOriginal,
  ListGroupIntegrationsDataResponse as ListGroupIntegrationsDataResponseOriginal,
  GroupIntegrationsData as GroupIntegrationsDataOriginal,
  GetGroupMembersGroupIdsRequest as GetGroupMembersGroupIdsRequestOriginal,
  GetGroupMembersGroupIdsResponse as GetGroupMembersGroupIdsResponseOriginal,
  GetGroupBMFeaturesRequest as GetGroupBMFeaturesRequestOriginal,
  GetGroupBMFeaturesResponse as GetGroupBMFeaturesResponseOriginal,
  BMFeatures as BMFeaturesOriginal,
  BMFeature as BMFeatureOriginal,
  BMFeatureWithLiterals as BMFeatureWithLiteralsOriginal,
  QueryJoinedGroupsWithMemberRequest as QueryJoinedGroupsWithMemberRequestOriginal,
  QueryJoinedGroupsWithMemberResponse as QueryJoinedGroupsWithMemberResponseOriginal,
  GetPrivacyRequest as GetPrivacyRequestOriginal,
  GetPrivacyResponse as GetPrivacyResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './social-groups-v2-group-groups.types.js';
